@if (selectedView === 'orders') {
  <mat-chip-listbox class="chip-list chip-filters" hideSingleSelectionIndicator="true">
    @for (chip of statusChips; track chip.status) {
      <mat-chip-option
        class="chip-item"
        [value]="chip.status"
        [selected]="selectedStatus === chip.status"
        (selectionChange)="onChipSelectedChange($event, chip.status)">
        <div class="chip-option">
          <div class="chip-icon">
            <i [attr.class]="'fa-' + (selectedStatus === chip.status ? 'solid' : chip.iconVariant) + ' ' + chip.icon"></i>
          </div>

          <div class="chip-label">
            <div class="chip-label-primary title-small">
              {{ chip.label }}
              <span class="button-badge title-small">{{ chip.count }}</span>
            </div>

            @if (chip.amount !== null) {
              <div class="chip-label-secondary body-small">
                {{ chip.amount | translocoCurrency: 'symbol' : { useGrouping: true, minimumFractionDigits: 2, maximumFractionDigits: 2 } }}
              </div>
            }
          </div>
        </div>
      </mat-chip-option>
    }
  </mat-chip-listbox>
}

<div class="searchbar-row">
  <mat-form-field appearance="outline" class="searchbar">
    <input matInput [placeholder]="'orders.ui.cercaClienteCodOrdineProd' | transloco" [formControl]="searchText">
  </mat-form-field>

  <button *uiCan="capabilityNames.ordineCrea" matButton="filled" type="button" class="new-order-button" (click)="newOrder()">
    <i class="fa-regular fa-plus"></i>
    {{ 'orders.ui.nuovoOrdine' | transloco }}
  </button>
</div>

<div class="view-bar">
  <mat-button-toggle-group
    class="toggle"
    hideSingleSelectionIndicator="true"
    [value]="selectedView"
    (change)="onViewChange($event.value)">
    @for (option of viewOptions; track option.value) {
      <mat-button-toggle [value]="option.value">{{ option.label }}</mat-button-toggle>
    }
  </mat-button-toggle-group>
</div>

@if (selectedView === 'orders') {
  <ui-table-view
    class="table-view"
    [columnsInfo]="columnsInfo"
    [data]="orders"
    [sortColumns]="currentSortColumns"
    (sortChange)="onSortChange($event)"
    (rowClicked)="onOrderClick($event)">
  </ui-table-view>
} @else {
  @if (draftsCount > 0) {
    <div class="drafts-banner">
      <i class="fa-solid fa-circle-info"></i>
      <span class="body-medium">
        {{ 'orders.ui.haiAncoraAperteLeBozzeRestano90GiorniPerQuelleConPreventivoArrivanoNotificheDiScadenza' | transloco: { value0: (draftsCount === 1 ? ('orders.ui.1Bozza' | transloco) : draftsCount + (" " + ('orders.ui.bozze' | transloco))) } }}
      </span>
    </div>
  }

  <mat-checkbox class="drafts-quotes-filter" [checked]="showOnlyQuotes" (change)="onShowOnlyQuotesChange($event.checked)">
    {{ 'orders.ui.mostraSoloBozzeConPreventivi' | transloco }}
  </mat-checkbox>

  @if (selectedDraftIds.size > 0) {
    <div class="drafts-selection-toolbar">
      <button matButton type="button" (click)="clearDraftsSelection()">
        <i class="fa-regular fa-xmark"></i>
        {{ selectedDraftIds.size === 1 ? ('orders.ui.1Selezionato' | transloco) : selectedDraftIds.size + (" " + ('orders.ui.selezionati' | transloco)) }}
      </button>

      <button matButton="outlined" type="button" (click)="deleteSelectedDrafts()">{{ 'orders.ui.elimina' | transloco }}</button>
    </div>
  }

  <ui-table-view
    class="table-view"
    [columnsInfo]="draftsColumnsInfo"
    [data]="drafts"
    [sortColumns]="currentSortColumns"
    (sortChange)="onSortChange($event)"
    (rowClicked)="onDraftClick($event)">
  </ui-table-view>
}

<mat-paginator
  class="paginator"
  [length]="totalItems"
  [pageSize]="pageSize"
  [pageIndex]="pageIndex"
  [pageSizeOptions]="[5, 10, 25]"
  [hidePageSize]="true"
  (page)="onPageChange($event)">
</mat-paginator>
